import { SelectContentEvent } from './schemas/multiple_teams/selectContent.schema'

export const createGenericSelectContentEvent = ({
  eventCategory,
  eventAction,
  eventLabel,
  eventValue = undefined,
  itemId,
}: {
  eventCategory: string
  eventAction: string
  eventLabel: string
  eventValue?: number
  itemId?: string
}): SelectContentEvent => {
  return {
    event: 'select_content',
    content_data: {
      content_type: `${eventCategory} | ${eventAction} | ${eventLabel}`
        .substring(0, 100)
        .toLowerCase(),
      item_id: itemId?.toLowerCase(),
    },
    // For GA3 backward compatibility
    event_data: {
      category: eventCategory.toLowerCase(),
      action: eventAction.toLowerCase(),
      label: `${eventLabel.toLowerCase()}${
        itemId ? ` | ${itemId.toLowerCase()}` : ''
      }`,
      non_interaction: true,
      value: eventValue,
    },
    // Web only //
    discount_data: undefined,
    ecommerce: undefined,
    error_data: undefined,
  }
}
